import { getActiveBranchId, getErpAuthState } from "../erpClient";

/** Default branch for POST /api/leads and /api/reminders (API default is 1). */
export function getDefaultBranchId() {
  const active = getActiveBranchId();
  if (active) return active;
  const u = getErpAuthState().user;
  const raw = u?.branch_id ?? u?.branchId ?? 1;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 1;
}
